// extracted by mini-css-extract-plugin
export default {"taskFormFromTasksContainer":"TaskFormAndSubmitTaskFormByTasks_taskFormFromTasksContainer__QRXbQ"};